import { apiFetch } from './apiClient';



function fromApi(c) {
  return {
    id:           c.id,
    codigo:       c.codigo,
    nome:         c.nome,
    empresa:      c.empresa      ?? '',
    cnpj:         c.cnpj         ?? '',
    cpf:          c.cpf          ?? '',
    telefone:     c.telefone     ?? '',
    email:        c.email        ?? '',
    camposExtras: c.campos_extras ?? [],
    status:       c.status       ?? 'ativo',
    leadId:       c.lead_id      ?? null,
    /* criado na aprovação do lead: bloqueado até o onboard concluir */
    onboardPendente: !!c.onboard_pendente,
    criadoEm:     c.criado_em    ?? '',
    niboCustomerId: c.nibo_customer_id ?? null,
    particularidades: c.particularidades ?? '',
    particularidadesSecoes: c.particularidades_secoes ?? [],
    particularidadesLinks:  c.particularidades_links  ?? [],
    nfCodigoTributacaoNacional: c.nf_codigo_tributacao_nacional ?? '',
    nfCodigoTributacaoMunicipal: c.nf_codigo_tributacao_municipal ?? '',
    nfDadosPagamento: c.nf_dados_pagamento ?? '',
    nfDescricaoServico:         c.nf_descricao_servico          ?? '',
    nfAliquotaIss:              c.nf_aliquota_iss               ?? '',
    nfCodigoMunicipioPrestacao: c.nf_codigo_municipio_prestacao ?? '',
    nfValorPadrao:              c.nf_valor_padrao               ?? '',
    nfCodigoMunicipioEmissor: c.nf_codigo_municipio_emissor   ?? '',
    nfInscricaoMunicipal:     c.nf_inscricao_municipal        ?? '',
    nfSerieDps:               c.nf_serie_dps                  ?? '1',
    nfRegimeTributario:       c.nf_regime_tributario          ?? 3,
    nfRegimeApuracaoSn:       c.nf_regime_apuracao_sn         ?? 1,
    nfRegimeEspecial:         c.nf_regime_especial            ?? 0,
    nfPossuiRetencaoPadrao:   c.nf_possui_retencao_padrao     ?? false,
    nfTipoRetencaoIssPadrao:  c.nf_tipo_retencao_iss_padrao   ?? 1,
    /* em qual lista do menu NF o cliente entra (NF-Essensials/NF-Clientes) */
    nfEssensials:             c.nf_essensials                 ?? false,
    nfCliente:                c.nf_cliente                    ?? false,
    nfIssFlexivel:            c.nf_iss_flexivel               ?? false,
    nfNumeroDpsInicial:       c.nf_numero_dps_inicial         ?? '',
    nfInformarIbsCbs:         c.nf_informar_ibs_cbs           ?? false,
    nfSituacaoPisCofins:      c.nf_situacao_pis_cofins         ?? '',
    nfReterInssPadrao:        c.nf_reter_inss_padrao           ?? false,
    nfAliquotaInss:           c.nf_aliquota_inss               ?? '',
    nfPercentualTributos:     c.nf_percentual_tributos         ?? '',
    /* endereço e cartão CNPJ (vêm do botão "Atualizar pela Receita") */
    cep:              c.cep              ?? '',
    logradouro:       c.logradouro       ?? '',
    numero:           c.numero           ?? '',
    complemento:      c.complemento      ?? '',
    bairro:           c.bairro           ?? '',
    municipio:        c.municipio        ?? '',
    uf:               c.uf               ?? '',
    codigoMunicipio:  c.codigo_municipio ?? '',
    nomeFantasia:     c.nome_fantasia    ?? '',
    naturezaJuridica: c.natureza_juridica ?? '',
    porte:            c.porte            ?? '',
    capitalSocial:    c.capital_social   ?? '',
    dataAbertura:     c.data_abertura    ?? '',
    situacaoCadastral: c.situacao_cadastral ?? '',
    opcaoSimples:     c.opcao_simples    ?? null,
    opcaoMei:         c.opcao_mei        ?? null,
    enquadramento:    c.enquadramento    ?? '',
    cnaePrincipal:    c.cnae_principal   ?? '',
    cnaePrincipalDescricao: c.cnae_principal_descricao ?? '',
    cnaesSecundarios: c.cnaes_secundarios ?? [],
    tipoAtividade:    c.tipo_atividade   ?? null,
    receitaAtualizadaEm: c.receita_atualizada_em ?? null,
    situacaoLicenciamento:            c.situacao_licenciamento              ?? '',
    dataUltimaRevisaoLicenciamento:   c.data_ultima_revisao_licenciamento   ?? '',
    vencimentoAvcb:                   c.vencimento_avcb                    ?? '',
    vencimentoLicenca:                c.vencimento_licenca                 ?? '',
  };
}

/* Por padrão NÃO traz quem está inativo no cadastro -- é o que alimenta as
   listas de seleção do sistema todo. A tela de Clientes (única que precisa
   enxergar e reativar inativo) chama com { incluirInativos: true }. */
export async function listarClientes({ incluirInativos = false } = {}) {
  const data = await apiFetch(`/clientes${incluirInativos ? '?incluirInativos=1' : ''}`);
  return data.map(fromApi);
}

export async function atualizarStatusCliente(id, status) {
  const data = await apiFetch(`/clientes/${id}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  });
  return fromApi(data);
}

export async function atualizarCliente(id, dados) {
  const data = await apiFetch(`/clientes/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(dados),
  });
  return fromApi(data);
}

/* puxa o cartão CNPJ e grava no cadastro -- campo vazio na Receita não
   apaga o que já está preenchido aqui */
export async function atualizarClientePelaReceita(id) {
  const r = await apiFetch(`/clientes/${id}/atualizar-receita`, { method: 'POST' });
  return { cliente: fromApi(r.cliente), cnaesSecundarios: r.cnaesSecundarios };
}

export async function criarCliente(form) {
  const data = await apiFetch('/clientes', {
    method: 'POST',
    body: JSON.stringify({
      codigo:  form.codigo,
      nome:    form.nome,
      empresa: form.empresa  ?? '',
      cnpj:    form.cnpj     ?? '',
      cpf:     form.cpf      ?? '',
      lead_id: form.leadId   ?? null,
    }),
  });
  return fromApi(data);
}

/* importa em massa quem já existe na Nibo mas ainda não está na nossa base
   -- entra como "pendente_validacao" pra alguém confirmar os dados depois */
export async function importarClientesNibo() {
  const data = await apiFetch('/clientes/importar-nibo', { method: 'POST' });
  return { ...data, items: (data.items || []).map(fromApi) };
}

/* ── Vínculo com o Nibo ── */
export const compararClientesNibo = () => apiFetch('/clientes/comparar-nibo');
export const buscarVinculoNibo   = (clienteId) => apiFetch(`/clientes/${clienteId}/nibo`);
export const buscarCandidatosNibo = (clienteId) => apiFetch(`/clientes/${clienteId}/nibo/buscar`);
export const vincularClienteNibo = (clienteId, niboCustomerId) => apiFetch(`/clientes/${clienteId}/nibo/vincular`, {
  method: 'POST',
  body: JSON.stringify({ niboCustomerId }),
});
export const criarClienteNibo = (clienteId, dados) => apiFetch(`/clientes/${clienteId}/nibo/criar`, {
  method: 'POST',
  body: JSON.stringify(dados),
});
export const atualizarClienteNibo = (clienteId, dados) => apiFetch(`/clientes/${clienteId}/nibo`, {
  method: 'PATCH',
  body: JSON.stringify(dados),
});
export const desvincularClienteNibo = (clienteId) => apiFetch(`/clientes/${clienteId}/nibo`, { method: 'DELETE' });
export const criarContatoClienteNibo = (clienteId, dados) => apiFetch(`/clientes/${clienteId}/nibo/contato`, {
  method: 'POST',
  body: JSON.stringify(dados),
});
